import * as React from "react";
import { SpringGrid, makeResponsive, enterExitStyle } from "react-stonecutter";
import { observable, action } from "mobx";
import { observer } from "mobx-react";

import * as CustomLists from "../../../models/customLists";
import { CategoryItemCard } from "components";
import { BrowseListsStore } from "../../../stores/BrowseListsStore";
import BackgroundLayer from "../../BackgroundLayer";
import { CenterHorizontally } from "layout";
import { ActivityCategoryItem } from "models/customLists/CategoryItem";

const Grid = makeResponsive(SpringGrid, {
    maxWidth: 1920,
    minPadding: 100,
});

export interface PreviewDialogProps extends React.Props<any> {
    store: BrowseListsStore;
}

@observer
export class PreviewDialog extends React.Component<PreviewDialogProps> {
    @observable private category: CustomLists.Category;
    @observable private height: number;
    @observable private columnWidth: number;
    @observable private gutterHeight: number;
    @observable private gutterWidth: number;

    constructor(props: any, context: any) {
        super(props, context);

        setTimeout(
            action(() => {
                this.category = this.props.store.categoryToPreview;
            }),
            300
        );

        this.height = 80;
        this.columnWidth = 380;
        this.gutterHeight = 50;
        this.gutterWidth = 50;
    }

    // Render UI
    // ------------------------------------------
    public render() {
        return (
            <div>
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        width: "100%",
                        zIndex: 1,
                    }}
                >
                    <BackgroundLayer
                        color="#000000"
                        opacity={0.7}
                        zIndex={-1}
                        onClickCallback={this.onBackgroundClicked}
                    />
                </div>
                <CenterHorizontally top={200} paddingBottom={200}>
                    <Grid
                        columnWidth={this.columnWidth}
                        gutterWidth={this.gutterWidth}
                        gutterHeight={this.gutterHeight}
                        height={this.height}
                        enter={enterExitStyle.fromBottom.enter}
                        entered={enterExitStyle.fromBottom.entered}
                        exit={enterExitStyle.fromBottom.enter}
                        perspective={1000}
                        springConfig={{ stiffness: 170, damping: 26 }}
                    >
                        {this.renderCards()}
                    </Grid>
                </CenterHorizontally>
            </div>
        );
    }

    private renderCards() {
        if (this.category === undefined) {
            return null;
        } else {
            let items = this.category.activityItems.map((item: ActivityCategoryItem) => {
                return (
                    <div key={item.key}>
                        <CategoryItemCard
                            category={this.category}
                            key={item.key}
                            item={item}
                            cardHeight={150}
                            fontSize={20}
                        />
                    </div>
                );
            });
            return items;
        }
    }

    // UI event handlers
    // ------------------------------------------
    @action
    private onBackgroundClicked = () => {
        this.category = undefined;
        setTimeout(
            action(() => {
                this.props.store.categoryToPreview = undefined;
                this.props.store.shouldShowPreview = false;
            }),
            300
        );
    };
}
